
























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../../components/charts/themes/walden.json'
@Component({
    components: {myTable,ECharts}
})
export default class extends AbpBase {
    @Prop({type:Object,default:{}}) data:any;
    @Watch('data')
    wD(){
        if(this.data.assayMonthPercent){
            let total = 0;
            this.data.assayMonthPercent.forEach(v => {
                total+=Number(v.quantity)
            })
            this.list = [...this.data.assayMonthPercent,{
                type:'合计',
                quantity:total,
                percent:'100%',
            }]
            this.detailList = this.data.assayMonthDetail
            this.renderEcharts(this.data.assayMonthPercent)
        }
    }
    list = []
    detailList = []
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        if(this.data.assayMonthPercent){
            console.log(this.data,111)
            let total = 0;
            this.data.assayMonthPercent.forEach(v => {
                total+=Number(v.quantity)
            })
            this.list = [...this.data.assayMonthPercent,{
                type:'合计',
                quantity:total,
                percent:'100%',
            }]
            this.detailList = this.data.assayMonthDetail
            this.renderEcharts(this.data.assayMonthPercent)
        }
    }
    detail(row:any){
        this.detailList = this.data.assayMonthDetail.filter((v:any)=>{
            if(row.type === '达标'){
                return v.standardsCount == 1
            }else if(row.type === '未达标'){
                return v.notStandardsCount == 1
            }else if(row.type === '超标'){
                return v.exceededCount == 1
            }else{
                return v.patientName
            }
        })
    }
    columns = [
        {
            title: '类型',
            key: 'type'
        },
        {
            title: '数量',
            key: 'quantity'
        },
        {
            title: '占比',
            key: 'percent'
        },
        {
            title: '操作',
            width:120,
            render:(h:any,p:any)=>{
                return h('span',{
                    style:{
                        color:'rgb(64, 158, 255)',
                        marginLeft:'40px',
                        cursor: 'pointer',
                    },
                    on:{
                        'click':()=>{
                            this.detail(p.row)
                        }
                    }
                },'详情')
            }
        },
    ]
    detailColumns = [
        {
            title: '患者姓名',
            key: 'patientName'
        },
        {
            title: '化验值',
            key: 'result'
        },
    ]
    renderEcharts(data:any){
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '年累计达标率统计',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['达标','不达标','超标'],
            },
            series : [
                {
                    name: '达标',
                    type: 'pie',
                    radius : '55%',
                    center: ['50%', '50%'],
                    label: {
                        normal: {
                            formatter: '{b}：{c}({d}%)',
                        }
                    },
                    data:data.map((v:any)=>{
                        return {
                            name:v.type,
                            value:v.quantity
                        }
                    })
                        
                },
            ]
        }
    }
    option:any = {}
}
